import { graphql } from '@/gql'

export const editUserGroupMutation = graphql(/* GraphQL */ `
  mutation EditUserGroup($input: UpdateUserGroupInput!, $usersFirst: Int!, $usersPage: Int) {
    updateUserGroup(input: $input) {
      ...UsersFragment
      ...UserGroupFragment
    }
  }
`)

export const createUserGroupMutation = graphql(/* GraphQL */ `
  mutation CreateGroup($input: CreateUserGroupInput!, $usersFirst: Int!, $usersPage: Int) {
    createUserGroup(input: $input) {
      ...UsersFragment
      ...UserGroupFragment
    }
  }
`)

export const deleteUserGroupMutation = graphql(/* GraphQL */ `
  mutation DeleteUserGroup($input: DeleteUserGroupInput!) {
    deleteUserGroup(input: $input) {
      id
    }
  }
`)
